import ConfirmDialog from "../../components/customHelpers/ConfirmDialog";
import Controls from "../../components/controls/Controls";
import Norecords from "../../components/customHelpers/Norecords";
import Loading from "../../components/customHelpers/Loading";

import Layout from "../../components/layout/Layout";
import {
  TableBody,
  TableRow,
  TableCell,
  Typography,
  makeStyles,
} from "@material-ui/core";

import { Grid, Toolbar, InputAdornment } from "@material-ui/core";
import { useEffect, useRef, useState } from "react";

import { MdOutlineDelete } from "react-icons/md";
import { IoMdAdd } from "react-icons/io";
import { AiOutlineSearch } from "react-icons/ai";
import useTable from "../../components/customHelpers/useTable";
import Notify from "../../components/customHelpers/Notify";
import Notification from "../../components/customHelpers/Notification";
import { FiEdit, FiEye } from "react-icons/fi";
import produce from "immer";

import Admin from "../../components/auth/Admin";
import SuperAdmin from "../../actions/manageAdmin";
import Popup from "../../components/customHelpers/Popup";
import AdminSignUp from "../../components/forms/superAdminSignup";
import { AiFillCheckCircle } from "react-icons/ai";
import { AiFillCloseCircle } from "react-icons/ai";

const headCells = [
  { id: "fullName", label: "Full Name" },
  { id: "email", label: "Email" },
  { id: "phoneNo", label: "Phone Number" },
  { id: "username", label: "UserName" },
  { id: "status", label: "Status" },
  { id: "actions", label: "Actions", disableSorting: true },
];
const useStyles = makeStyles((theme) => ({
  activated: {
    color: theme.palette.success.main,
    fontWeight: "bold",
  },
  deactivated: {
    color: theme.palette.error.main,
    fontWeight: "bold",
  },
}));
const SuperAdminPage = () => {
  const { NotifyMessage, notify, setNotify } = Notify();
  const classes = useStyles();

  const { viewAllAdmin, updateAdmin, deleteAdmin } = SuperAdmin();

  const [admins, setAdmins] = useState([]);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [edite, setEdit] = useState(false);

  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;
  useEffect(() => {
    getAllAdmin();
  }, [reload]);

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const getAllAdmin = () => {
    setValues({ ...values, loading: true });
    viewAllAdmin().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
        setValues({
          ...values,
          loading: false,
        });
      } else if (data.admin) {
        setValues({
          ...values,
          loading: false,
        });
        setAdmins(data.admin);
      }
    });
  };

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(admins, headCells, filterFn);

  const handleSearch = (e) => {
    e.target.value = e.target.value.trimLeft();
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        const columns = ["fullName", "email", "username", "phoneNo"];

        if (target.value == "") return items;
        else {
          return items.filter((x) => {
            return columns.some((column) => {
              return (
                x[column]
                  .toString()
                  .toLowerCase()
                  .indexOf(target.value.toLowerCase()) > -1
              );
            });
          });
        }
      },
    });
  };

  const updateOrganizationStatus = async (id, currentStatus) => {
    const newStatus = !currentStatus;
    updateAdmin({ inactive: newStatus }, id).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else {
        setAdmins((prev) =>
          prev.map((org) =>
            org.id === id ? { ...org, inactive: newStatus } : org
          )
        );
        NotifyMessage({
          message: `Status updated successfully.`,
          type: "success",
        });
      }
    });
  };

  const onDelete = (Id) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    deleteAdmin(Id).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
        setValues({
          ...values,
          loading: false,
        });
      } else {
        NotifyMessage({
          message: data.message,
          type: "success",
        });
        setValues({ ...values, reload: !reload });
        setAdmins(
          produce(admins, (draft) => {
            const index = admins.findIndex((staff) => staff.id === Id);
            if (index !== -1) draft.splice(index, 1);
          })
        );
      }
    });
  };
  return (
    <Layout>
      <Admin>
        <div className="card">
          <Typography variant="h6" className="page-header">
            Admin's
          </Typography>
          <Toolbar>
            <Controls.Input
              label="Search admin"
              className="searchInput"
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AiOutlineSearch />
                  </InputAdornment>
                ),
              }}
              onChange={handleSearch}
            />

            <Controls.Button
              text="Register"
              variant="outlined"
              startIcon={<IoMdAdd />}
              className="newButton"
              onClick={() => {
                setOpenPopup(true);
                setRecordForEdit(null);
                setEdit(false);
              }}
            />
          </Toolbar>

          <Grid container>
            <Grid item xs={12} className="card__body">
              {loading ? (
                <Loading />
              ) : (
                <>
                  {" "}
                  <TblContainer>
                    <TblHead />
                    <TableBody>
                      {recordsAfterPagingAndSorting().length > 0 ? (
                        recordsAfterPagingAndSorting().map((item) => (
                          <TableRow key={item.id}>
                            <TableCell>{item.fullName}</TableCell>
                            <TableCell>{item.email}</TableCell>
                            <TableCell>{item.phoneNo}</TableCell>
                            <TableCell>{item.username}</TableCell>
                            <TableCell
                              className={
                                item.inactive
                                  ? classes.deactivated
                                  : classes.activated
                              }
                            >
                              {item.inactive ? "Deactivated" : "Activated"}
                            </TableCell>
                            <TableCell>
                              <Controls.ActionButton
                                color="secondary"
                                title="Delete"
                                onClick={() => {
                                  setConfirmDialog({
                                    isOpen: true,
                                    title:
                                      "Are you sure to delete this Superadmin?",
                                    subTitle: "You can't undo this operation",
                                    onConfirm: () => {
                                      onDelete(item.id);
                                    },
                                  });
                                }}
                              >
                                <MdOutlineDelete fontSize="medium" />
                              </Controls.ActionButton>
                              <Controls.ActionButton
                                color="secondary"
                                onClick={() =>
                                  updateOrganizationStatus(
                                    item.id,
                                    item.inactive
                                  )
                                }
                                title={item.inactive ? "Activat" : "Deactivat"}
                              >
                                {item.inactive ? (
                                  <AiFillCheckCircle fontSize="medium" />
                                ) : (
                                  <AiFillCloseCircle fontSize="medium" />
                                )}
                              </Controls.ActionButton>
                      
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <Norecords col={6} />
                      )}
                    </TableBody>
                  </TblContainer>
                  <TblPagination />
                </>
              )}
            </Grid>
          </Grid>

          <ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
          <Notification notify={notify} setNotify={setNotify} />
        </div>
        <Popup
          title="Super Admin Form"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <AdminSignUp
            NotifyMessage={NotifyMessage}
            setOpenPopup={setOpenPopup}
            recordForEdit={recordForEdit}
            getAllAdmin={getAllAdmin}
            edite={edite}
          />
        </Popup>
     
      </Admin>
    </Layout>
  );
};

export default SuperAdminPage;
